/**
 * Constant to store various notification types we may see in the application.
 */
export const NotificationTypes = {
  NO_COVERAGE_INFORMATION: "NO_COVERAGE_INFORMATION",
  TUTORIAL_COMPLETE: "TUTORIAL_COMPLETE",
};
